// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ListPlus as RawListPlus } from "lucide-react";
export const ListPlus = /* @__PURE__ */ createIcon(RawListPlus, "ListPlus", 2);
